import { Orders } from '@/firebase/index';

export default {
  async createOrder(order) {
    const value = await Orders.add(order);
    console.log('order added', order);
    return value;
  },

  getOrder(id) {
    return Orders.doc(id).get();
  },
};
